import * as React from 'react'
import { css } from 'glamor'
import { colors, settings } from '@dooer/react-ui-kit'

const SvgComponent = (props?: any) => (
  <svg
    aria-labelledby="checkIconTitle checkIconDesc"
    color={colors.accents.positive}
    fill="currentColor"
    viewBox="0 0 66 66"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title id="checkIconTitle">{'Check'}</title>
    <desc id="checkIconDesc">{'Check icon'}</desc>
    <path
      d="M32.75 65.5C14.663 65.5 0 50.837 0 32.75S14.663 0 32.75 0 65.5 14.663 65.5 32.75 50.837 65.5 32.75 65.5zm-5.01-15.52c1.12 0 2.23-.43 3.08-1.28l24-24a4.37 4.37 0 0 0 0-6.17 4.37 4.37 0 0 0-6.17 0L27.74 39.44l-7.82-7.82a4.37 4.37 0 0 0-6.17 0 4.37 4.37 0 0 0 0 6.17L24.66 48.7c.85.85 1.96 1.28 3.08 1.28z"
      fillRule="nonzero"
    />
  </svg>
)

const CheckIcon: React.FC<{ props?: any }> = (props: any) => (
  <SvgComponent {...css({ height: '52px', width: '52px', marginBottom: settings.spacing.large })} {...props} />
)

export default CheckIcon
